import React, { createContext, useContext } from 'react';

import { FundOfferEntityNormalized } from '../../../../../../../store/product/types';

interface FundsAssetContextReceivedData {}

interface FundsAssetContextData extends FundsAssetContextReceivedData {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  offerSelected: FundOfferEntityNormalized | undefined;
  setOfferSelected: React.Dispatch<React.SetStateAction<FundOfferEntityNormalized | undefined>>;
}

interface Props extends FundsAssetContextReceivedData {
  children: React.ReactNode;
}

const FundsAssetContext = createContext<FundsAssetContextData>({} as FundsAssetContextData);

const FundsAssetProvider: React.FC<Props> = ({ children, ...props }) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [offerSelected, setOfferSelected] = React.useState<FundOfferEntityNormalized>();

  return (
    <FundsAssetContext.Provider
      value={{
        ...props,
        modalOpen,
        setModalOpen,
        offerSelected,
        setOfferSelected,
      }}>
      {children}
    </FundsAssetContext.Provider>
  );
};

const useFundsAssetContext = (): FundsAssetContextData => {
  const context = useContext(FundsAssetContext);

  if (!context) {
    throw new Error('useFundsAssetContext must be used within an FundsAssetContext');
  }
  return context;
};

export { FundsAssetProvider, useFundsAssetContext, FundsAssetContextData };
